import React from 'react'
import styled from 'styled-components'
import { Currency } from '../../model'
import { ApproveTokenForDelayButton } from './TokenApprovalButton'

interface ApprovalsButtonsProps {
  first?: Currency
  second?: Currency
  needFirstApproval: boolean
  needSecondApproval: boolean
}

export function ApprovalButtons({ first, second, needFirstApproval, needSecondApproval }: ApprovalsButtonsProps) {
  if (!first || !second || (!needFirstApproval && !needSecondApproval)) {
    return null
  }
  return (
    <Approvals>
      {needFirstApproval && <ApproveTokenForDelayButton key={first.symbol} currency={first} />}
      {needSecondApproval && <ApproveTokenForDelayButton key={second.symbol} currency={second} />}
    </Approvals>
  )
}

export const Approvals = styled.div`
  margin-bottom: 12px;
  padding: 0 20px;
  display: block;

  > * {
    &:last-child {
      margin-top: 10px;
    }
  }
`
